export interface LatLngLiteral {
  lat: number;
  lng: number;
}

export const FALLBACK_MAP_CENTER: LatLngLiteral = {
  lat: 54.620721,
  lng: -113.336903,
};
